<template>
    <div>
        <b-form v-if="! loading" @submit="createLevel($event)">
            <div class="row" ref="formTop">
                <b-card class="col-12 col-md-12 col-lg-12">
                    <b-card-title title-tag="h5" title="Create Member Level"></b-card-title>
                    <b-card-body class="px-0">
                        <b-form-group label="Level Name" label-for="level_name">
                            <b-form-input id="level_name" v-model="memberLevel.title" required></b-form-input>
                        </b-form-group>
                        <b-form-group label="Site" label-for="level_site">
                            <b-form-select id="level_site" v-model="memberLevel.site_id" :options="siteOptions" required></b-form-select>
                        </b-form-group>
                        <b-form-group label="Universal" label-for="level_universal">
                            <b-form-checkbox id="level_universal" v-model="memberLevel.universal" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label="Send Annual Reminder" label-for="send_reminder">
                            <b-form-checkbox id="send_reminder" v-model="memberLevel.send_reminder" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label="Monthly" label-for="level_monthly">
                            <b-form-checkbox id="level_monthly" v-model="memberLevel.monthly" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label="Annual" label-for="level_annual">
                            <b-form-checkbox id="level_annual" v-model="memberLevel.annual" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label="Discount" label-for="level_discount">
                            <b-form-checkbox id="level_discount" v-model="memberLevel.discount" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label="Discount Amount" label-for="level_discount_amount">
                            <b-form-input id="level_discount_amount" type="number" v-model="memberLevel.discount_amount" required></b-form-input>
                        </b-form-group>

                        <b-button type="submit" @click="createLevel($event)" :disabled="creating">
                            <span v-if="memberLevel.id">Edit</span><span v-else>Create</span>
                        </b-button>
                    </b-card-body>
                </b-card>
            </div>
        </b-form>
    </div>
</template>

<script>
export default {
    props: {
        memberLevelRaw: {
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            creating: false,
            sites: Sites,
            memberLevel: {
                id: null,
                title: null,
                site_id: null,
                universal: false,
                send_reminder: false,
                default: false,
                monthly: false,
                annual: false,
                discount: false,
                discount_amount: 0,
            },
        }
    },
    computed: {
        siteOptions() {
            return this.sites.map(site => {
                return { value: site.id, text: site.title };
            });
        },
    },
    methods: {
        createLevel(event) {
            event.preventDefault();
            this.creating = true;
            if (this.memberLevelRaw && this.memberLevelRaw.id) {
                axios.put(this.$routes.route('memberlevel.update', {memberLevel: this.memberLevel.id}), this.memberLevel)
                    .then(response => {
                        this.creating = false;
                        window.location.href = this.$routes.route('memberlevel.index');
                    })
                    .catch(error => {
                        this.creating = false;
                        console.log(error);
                    });
            } else {
                axios.post(this.$routes.route('memberlevel.store'), this.memberLevel)
                    .then(response => {
                        this.creating = false;
                        window.location.href = this.$routes.route('memberlevel.index');
                    })
                    .catch(error => {
                        this.creating = false;
                        console.log(error);
                    });
            }
        },
        init() {
            if (this.memberLevelRaw) {
                this.memberLevel = this.memberLevelRaw;
            }

            this.loading = false;
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>